import { Box, BoxProps } from "@twilio-paste/core/box";
import React from "react";

export const SidebarNestedItem: React.FC<BoxProps> = ({ children, ...props }) => (
    <Box
        as="li"
        marginTop="space20"
        marginBottom="space20"
        fontSize={["fontSize50", "fontSize50", "fontSize30"]}
        lineHeight="lineHeight20"
        {...props}
    >
        {children}
    </Box>
);
